import React, { useState } from 'react';
import { resolveBlogImageUrl } from '../utils/blogImage.js';

const BlogImage = ({ title, imageUrl, slug, size = 'medium', className = '' }) => {
    const [hasError, setHasError] = useState(false);

    const resolvedUrl = resolveBlogImageUrl({ title, slug, imageUrl });
    const displayUrl = hasError
        ? resolveBlogImageUrl({ title, slug, imageUrl: null })
        : resolvedUrl;

    const isSvg = displayUrl?.toLowerCase().endsWith('.svg');
    const fitClass = isSvg ? 'object-contain bg-slate-900' : 'object-cover';

    const sizeConfig = {
        large: {
            className: `h-[400px] w-full ${fitClass} rounded-lg shadow-lg`
        },
        medium: {
            className: `h-full w-full ${fitClass} rounded-lg shadow-md`
        }
    };

    const config = sizeConfig[size] || sizeConfig.medium;
    const imageClassName = className ? `${config.className} ${className}` : config.className;

    return (
        <img
            src={displayUrl}
            alt={title}
            className={imageClassName}
            onError={(event) => {
                event.currentTarget.onerror = null;
                setHasError(true);
            }}
        />
    );
};

export default BlogImage;
